/**
 * Copyright (c) 2023, Mohamed eRrais (merrais / MeR)
 * mohamed@errais.net
 * https://ocr.1ai.ma, https://akademy.ma, https://digitalservices.ma, https://sites.errais.net, https://2us.ma, 
 * محمد الرايس
 * Rais Digital Services
 * 231023 1504 : From math.akademy.ma
 * 240701 1259 : From tajwyd.akademy.ma
 * 241001 1819 : From ocr.1ai.ma (Api.Get  new Nodes in .Net)
**/

import React,{useState, useEffect} from 'react'
import '../meTree/meTree.css'
import Api, {Fetch} from '../Api'
import Config from '../Config/en'

const EvalTree = ({entity, team, onChange, Message=null}) => {
    const [loaded, Load] = useState(false)
    const [refreshed, Refresh] = useState('')
    const [selected, Select] = useState({level:'', id:0, parent:0})
    const [tree, Tree]= useState([])

    useEffect(() => {
        Load(false)
    }, [entity])

    
    useEffect(() => {
        //alert(`EvalTree ${loaded}`)
        if(!loaded) {
            let request = `${entity}/Nodes`
            
            Api.get(request)
            .then(response => {
                //console.log(response.data); alert(request)
                Tree(response.data)
                Load(true)
            })
            .catch(error => {
                Message && Message(error) //; console.error(error)
            })
        }
    }, [loaded])

    useEffect(()=>{
        if(selected.level.length>0 && selected.id>0) {
            Refresh(`${selected.level}-${selected.id}`)
        }
    },[tree])

    // const setNodes = (items) => {} from ocr.1ai.ma
    
    const onCollapse = (item) => {
        const ul = item.querySelector('ul')
        if (ul) {
            for (let i = 1; i < 5; i++) {
                if (item.classList.contains(`Node${i}`)) {

                    const nodes = item.querySelectorAll(`.Node${i+1}`)
                    nodes.forEach(function(node) {
                        if (node.classList.contains('collapsed')) {
                            node.classList.remove('collapsed');
    
                        } else {
                            node.classList.add('collapsed');
                        }
                    })

                }
            }            
        }

        if(item && !item.classList.contains('selected')) {
            const lis = document.getElementById('meTree').querySelectorAll('li')
            lis.forEach(li => {
                if (li.classList.contains('selected')) {
                    li.classList.remove('selected')
                }
            })
            item.classList.add('selected')  
        }

    }  
    
    useEffect(()=>{
        // Etat(selected.entity); alert(selected.entity)
        onChange && onChange(selected)
    }, [selected])
     
    const onNode = (e, parent=0) => {

        if(e) {
            onCollapse(e.target.parentElement)
            let ss = e.target.id.split('-',)
            if(ss?.length===2) {
                Select({level:ss[0], id:ss[1], parent:parent})                
            }

            //alert(`${e.target.id} => ${ss[0]} ${ss[1]} ${e.target.innerText} parent ${parent}`)
            if(e.target.innerText==='+'){
                if (e.shiftKey) {
                    const data = {
                        Entity: ss[0],
                        ParentId: parent, // parentElement
                        Name:ss[0]
                    }
                    Fetch('data', data, e.target.parentElement)
                    .then(item => {
                        e.target.innerText=ss[0]
                    })
                }
            }
        }
    }

    const onRefresh = (e) => {
        Refresh('')
        Load(false)
    }

    useEffect(()=>{
        if(refreshed.length>0) {
            Message(`Refresh ${refreshed}`)

            const uls = document.getElementById('meTree')?.querySelectorAll('ul')
            uls?.forEach(ul => {            
                const lis = ul?.querySelectorAll('li')
                lis?.forEach(li => {
                    const label=li.querySelector('.label')?.id //; alert(`${label} === ${refreshed}`)
                    if (label===refreshed) {
                        //alert(label)

                        var pl=li?.parentElement
                        while(pl?.tagName!=='DIV'){
                            if(pl?.tagName==='LI'){
                                if (pl.classList.contains('collapsed')) {
                                    //alert(pl.id)
                                    pl.classList.remove('collapsed')
                                }
                            }
                            pl=pl?.parentElement
                            
                            if(pl?.tagName==='DIV'){
                                if (!li.classList.contains('selected')) {
                                    li.classList.add('selected')   
                                }                                    
                            }
                        }
                        //console.log(li.parentElement) ;alert(label)
                        
                        //li.classList.add('selected')                        
                    }
                })
            })
        }   
    },[refreshed])
 
    return (
        loaded ? 
        <div id="treeContainer">   
        <span className="label" style={{fontSize:'1.2rem', color:'silver', padding:'1rem'}} id={`Root-0`} onClick={(e) => onRefresh(e)}>{Config.Description}</span>
        <ul id="meTree">
        { tree.map(node => (
                <li className="root Node1" value={node.Id} id={`Node1-${node.Id}`}>
                    <span className="label" title={node.Description} onClick={(e) => onNode(e,node.Id)} id={`Level1-${node.Id}`}>{node.Text}</span>
                <ul>
                { node.Nodes.map(node => (
                    <li className='Node2 collapsed' id={`Node2-${node.Id}`}>
                        <span className="label" title={node.Description} onClick={(e) => onNode(e,node.Id)} id={`Level2-${node.Id}`}>{node.Text}</span>
                    <ul>
                    { node.Nodes.map(node => (
                    <li className='Node3 collapsed' id={`Node3-${node.Id}`}>
                        <span className="label" title={node.Description} onClick={(e) => onNode(e,node.Id)} id={`Level3-${node.Id}`}>{node.Text}</span>

                    <ul>
                    { node.Nodes.map(node => (
                        <li className='Node4 collapsed' id={`Node4-${node.Id}`}>
                            <span className="label" title={node.Description} onClick={(e) => onNode(e,node.Id)} id={`Level4-${node.Id}`}>{node.Text}</span>
                        
                        </li>
                        ))
                    }                
                    </ul>
                    </li>
                ))
                }                
                    </ul>
                    </li>
                ))
                }                
                </ul>
                </li>
            ))
        }
    </ul> 
    </div> 

    : <div>Nodes are loading...</div> 
    )
}

export default EvalTree